import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "like-icon",
  "use": "like-icon-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"like-icon\"><text fill=\"#F0455A\" fill-rule=\"evenodd\" font-family=\"AppleColorEmoji, Apple Color Emoji\" font-size=\"12\" letter-spacing=\".343\" transform=\"translate(-338 -284)\"><tspan x=\"338\" y=\"297\">👍</tspan></text></symbol>"
});
var result = sprite.add(symbol);
export default symbol